var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".oi-donation-form .corner:before{content:\"\";display:inline-block;-webkit-clip-path:polygon(0 0,35px 35px,35px 0);clip-path:polygon(0 0,35px 35px,35px 0);height:35px;width:35px;position:absolute;top:0;right:0;cursor:pointer;background-size:33px 33px;background-position:100% 0;background-repeat:no-repeat}.oi-donation-form .corner.lang-ru:before{background-image:url(" + escape(require("../../assets/en.png")) + ")}.oi-donation-form .corner.lang-en:before{background-image:url(" + escape(require("../../assets/ru.png")) + ")}", ""]);

// exports
